import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Layout from './Components/Layout/Layout';
import Home from './Components/Home/Home';
import About from './Components/About/About';
import Chefs from './Components/Chefs/Chefs';
import Testimonials from "./Components/Testimonials/Testimonials";
import Contact from "./Components/Contact/Contact";
import Faqs from "./Components/Faqs/faqs";
import AllProducts from "./Components/AllProducts/AllProducts";
import ProductsDetails from "./Components/ProductsDetails/ProductsDetails";
import Cart from "./Components/Cart/Cart";
import Blog from "./Components/Blog/Blog";
import OurBlog from "./Components/OurBlog/OurBlog";
import Checkout from "./Components/Checkout/Checkout";
import Register from "./Components/Register/Register";
import Login from './Components/Login/Login';
import Profile from './Components/Profile/Profile';
import { useAuth } from './Components/Context/Auth';

function ProtectedRoute({ children }) {
  const { isLoggedIn } = useAuth();
  const token = localStorage.getItem('token');
  const loggedIn = isLoggedIn || !!token;
  if (!loggedIn) return <Login />;
  return children;
}

function App() {
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<ProtectedRoute><About /></ProtectedRoute>} />
          <Route path="chefs" element={<ProtectedRoute><Chefs /></ProtectedRoute>} />
          <Route path="testimonials" element={<ProtectedRoute><Testimonials /></ProtectedRoute>} />
          <Route path="contact" element={<ProtectedRoute><Contact /></ProtectedRoute>} />
          <Route path="faqs" element={<ProtectedRoute><Faqs /></ProtectedRoute>} />
          <Route path="all-products" element={<ProtectedRoute><AllProducts /></ProtectedRoute>} />
          <Route path="product/:id" element={<ProtectedRoute><ProductsDetails /></ProtectedRoute>} />
          <Route path="cart" element={<ProtectedRoute><Cart /></ProtectedRoute>} />
          <Route path="blog" element={<ProtectedRoute><Blog /></ProtectedRoute>} />
          <Route path="our-blog" element={<ProtectedRoute><OurBlog /></ProtectedRoute>} />
          <Route path="checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
          <Route path="profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Routes>
    </>
  );
}

export default App;
